import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  HostBinding,
} from '@angular/core';
import { isObservable, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseInputComponent } from '../../../common/base-input.component';
import { IDropdownOptions } from './dropdown.interface';
import { OnInit } from '@angular/core';

@Component({
  selector: 'nibtravel-dropdown',
  templateUrl: './dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownComponent
  extends BaseInputComponent
  implements OnInit, OnDestroy
{
  internalOptions!: IDropdownOptions[];
  destroy$ = new Subject<void>();
  @HostBinding('class') class = 'input-group nib-dropdown';
  @Input()
  set options(value: IDropdownOptions[] | Observable<IDropdownOptions[]>) {
    if (isObservable(value)) {
      value.pipe(takeUntil(this.destroy$)).subscribe((options) => {
        this.internalOptions = options;
        this.setupDefaultValue();
        this.cd.markForCheck();
      });
    } else {
      this.internalOptions = value;
      this.setupDefaultValue();
      this.cd.markForCheck();
    }
  }
  @Input()
  enableDefaultOption = false;
  @Input()
  defaultOptionText = '';

  // eslint-disable-next-line @angular-eslint/no-output-rename
  @Output('selected') valueChange = new EventEmitter();

  ngOnInit(): void {
    this.setupDefaultValue();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  writeValue(value: any): void {
    if (value && this.internalOptions) {
      this.internalOptions = this.internalOptions.map((option) => ({
        ...option,
        ...{ selected: option.value === value },
      }));
    }
    super.writeValue(value);
  }

  // Set value of default selection to the form control.
  private setupDefaultValue() {
    if (this.internalOptions) {
      const selectedOption = this.internalOptions.find((o) => o.selected);
      if (selectedOption) {
        this.ngControl?.control?.setValue(selectedOption.value);
      }
    }
  }
}
